Vue.component('NeqasSamplesIndexComponent', require('./components/NeqasSamplesIndexComponent').default);
Vue.component('NeqasSamplesDataTable', require('./components/partials/NeqasSamplesDataTable').default);
Vue.component('QualityControlIndexComponent', require('./components/QualityControlIndexComponent').default);
Vue.component(
    'QualityControlDevicesDataTable',
    require('./components/partials/QualityControlDevicesDataTable').default
);
Vue.component('NeqasSampleReportsModal', require('./components/partials/NeqasSampleReportsModal').default);
Vue.component('NeqasSampleReportTable', require('./components/partials/NeqasSampleReportTable').default);

Vue.component('HoribaSamplesIndexComponent', require('./components/HoribaSamplesIndexComponent').default);

Vue.component('HoribaIndexComponent', require('./components/HoribaIndexComponent').default);
Vue.component('HoribaDataTable', require('./components/partials/HoribaDataTable').default);
Vue.component('HoribaGetComponent', require('./components/HoribaGetComponent').default);

Vue.component('HoribaSamplesDataTable', require('./components/partials/HoribaSamplesDataTable').default);
Vue.component('HoribaSamplesGroupDataTable', require('./components/partials/HoribaSamplesGroupDataTable').default);

Vue.component('ProbeDataTable', require('./components/partials/ProbeDataTable').default);
